import styled from 'styled-components';

import { RadioButtonField, PhoneField, TextareaField } from '~fields';
import PatientBedFields from './PatientBedFields';
import SeparateBedFields from './SeparateBedFields';
import OtherCleanupFields from './OtherCleanupFields';

const BedCleanForm = props => {
  const { cleanupType } = props.formik.values;

  return (
    <Wrapper>
      <RadioButtonField name="cleanupType" required pills />

      {cleanupType === 'PATIENT_BED' && <PatientBedFields {...props} />}
      {cleanupType === 'SEPARATE_BED' && <SeparateBedFields {...props} />}
      {cleanupType === 'OTHER_CLEANUP' && <OtherCleanupFields {...props} />}

      <PhoneField name="contactPhone" />
      <TextareaField name="additionalInfo" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export default BedCleanForm;
